// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"247":"6b881284074cd5d1","419":"b7f50addda798cff","721":"1d9b9be8a6759af1","773":"cc4300bfb21dd0dc","931":"f58a73c60d3ea494"}[chunkId] + ".js";
};